import {useGetAllAudiencesQuery} from "../../core/api/audience-api";
import Loading from "../../components/Common/Loading";
import {
    Autocomplete,
    Box,
    Card,
    CardContent,
    Chip,
    FormControl,
    FormHelperText,
    Grid,
    InputLabel,
    MenuItem,
    Select, TextField,
    Typography
} from "@mui/material";
import Audience from "./AudienceInfo/Audience";

export const AudienceSelectList  = ({
    setSelectedAudience, selectedAudience, hasError
}) => {

    const {
        data,
        isLoading,
        isSuccess,
        isError,
        isFetching,
        error
    } = useGetAllAudiencesQuery()

    const handleChange = (event) => {
        setSelectedAudience(event.target.value);
    };

    const getSelectedAudienceData = () => {
        if (!selectedAudience || !data) return null;
        return data.find(audience => audience.id === selectedAudience);
    };

    const selectedData = getSelectedAudienceData();

    const renderFilterInfo = (filter) => {
        const filterItems = [];

        if (filter.platform) {
            filterItems.push(`Platform: ${filter.platform}`);
        }

        if (filter.include && filter.include.length > 0) {
            filterItems.push(`Include: ${filter.include.join(', ')}`);
        }

        if (filter.includeAll && filter.includeAll.length > 0) {
            const includeAllItems = filter.includeAll.map(item =>
                `${item.parameter || 'Parameter'}: ${item.values.join(', ')}`
            ).join('; ');
            filterItems.push(`Include All: ${includeAllItems}`);
        }

        if (filter.exclude && filter.exclude.length > 0) {
            filterItems.push(`Exclude: ${filter.exclude.join(', ')}`);
        }

        if (filter.excludeAll && filter.excludeAll.length > 0) {
            const excludeAllItems = filter.excludeAll.map(item =>
                `${item.parameter || 'Parameter'}: ${item.values.join(', ')}`
            ).join('; ');
            filterItems.push(`Exclude All: ${excludeAllItems}`);
        }

        if (filter.numberRange && filter.numberRange.length > 0) {
            filterItems.push(`Range: ${filter.numberRange.join(', ')}`);
        }

        if (filter.versionRange && filter.versionRange.length > 0) {
            filterItems.push(`Version: ${filter.versionRange.join(', ')}`);
        }

        return filterItems.length > 0 ? filterItems : ['No filters applied'];
    };

    return <>
        <Loading isLoading={isLoading} error={error} isError={error}>
            <Grid container spacing={2}>
                <Grid item size={6}>
                {data!=undefined&&<>
                    <FormControl fullWidth variant="outlined" sx={{ mb: 2 }}>

                        <Autocomplete
                            options={data}
                            getOptionLabel={(option) => option.title}
                            value={data.find(audience => audience.id === selectedAudience) || null}
                            onChange={(event, newValue) => {
                                handleChange({ target: { value: newValue ? newValue.id : '' } });
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Select Audience"
                                    error={hasError}
                                />
                            )}
                            renderOption={(props, option) => (
                                <li {...props} key={option.id}>
                                    {option.title}
                                </li>
                            )}
                            noOptionsText="No audiences found"
                            isOptionEqualToValue={(option, value) => option.id === value.id}
                        />

                        {hasError && (
                            <FormHelperText error>
                                Required field
                            </FormHelperText>
                        )}

                    </FormControl>

                    {selectedData&&<>
                        <Typography variant="body1" color="text.secondary" paragraph>
                            {selectedData.description}
                        </Typography>
                        <Box sx={{ mb: 2 }}>
                            <Typography variant="subtitle1" component="h4" gutterBottom>
                                Target Size:
                                <Chip
                                    label={selectedData?.statistics===null||selectedData?.statistics?.targetSize===null?'calculating...':parseInt(selectedData?.statistics?.targetSize)}
                                    color="primary"
                                    size="small"
                                    sx={{ ml: 1 }}
                                />
                            </Typography>
                        </Box>
                    </>}
                </>}
                </Grid>
                <Grid item size={6}>
                    {selectedData && (
                        <Card variant="outlined" sx={{ mt: 0 }}>
                            <CardContent>
                                <Box>
                                    <Typography variant="subtitle1" component="h4" gutterBottom>
                                        Filters:
                                    </Typography>
                                    <Audience key={1} audience={selectedData.filter}></Audience>

                                </Box>

                            </CardContent>
                        </Card>
                    )}
                </Grid>
            </Grid>
        </Loading>

    </>

}